<div class="breadcrumb_outer" style="justify-content: flex-end;">
    <!-- <ul class="breadcrumb">
        <li>
            <a>{{ company_name }}:</a>
        </li>
        <li class="active" *ngFor="let item of breadcrumbsArray; let i = index">
            <a (click)="goToPageLink(item.page_ref)">
                {{ item.page_title }}
            </a>
        </li>
    </ul> -->
    <div class="right">
        <span>{{ today }}</span>
    </div>

    <div class="tag_powered_by">
        <span>Powered by: <b>Enertics</b></span>
    </div>
</div>
<div class="Content_outer">
    <div class="row">
        <div class="col-md-12">
            <div class="col-md-12 pl-1">
                <div class="dashboard-header">
                    <div class="title-section">
                        <h1>Uptime Dashboard</h1>
                        <p>System monitoring and performance metrics</p>
                    </div>

                    <div class="controls-section">
                        <!-- Month Selection Dropdown -->
                        <div class="month_container">
                            <div class="month-selector">
                                <select class="month-dropdown" [(ngModel)]="selectedMonth" (change)="onMonthChange()">
                                    <option value="01">January</option>
                                    <option value="02">February</option>
                                    <option value="03">March</option>
                                    <option value="04">April</option>
                                    <option value="05">May</option>
                                    <option value="06">June</option>
                                    <option value="07">July</option>
                                    <option value="08">August</option>
                                    <option value="09">September</option>
                                    <option value="10">October</option>
                                    <option value="11">November</option>
                                    <option value="12">December</option>
                                </select>
                            </div>

                            <!-- Refresh Button -->
                            <button class="refresh-btn" (click)="refreshData()">
                                <i class="fas fa-sync-alt"></i>
                                Refresh
                            </button>
                        </div>

                        <div class="date-txt">{{selected_time_range_txt}}</div>
                    </div>
                </div>

                <!-- Tab Navigation -->
                <div class="tabs-container">
                    <ul class="nav nav-tabs custom-tabs" role="tablist">
                        <li class="nav-item">
                            <button class="nav-link" [class.active]="activeTab === 'applications'"
                                (click)="onTabChange('applications')">
                                <i class="fas fa-layer-group"></i>
                                <span>Applications</span>
                            </button>
                        </li>

                        <li class="nav-item">
                            <button class="nav-link" [class.active]="activeTab === 'servers'"
                                (click)="onTabChange('servers')">
                                <i class="fas fa-server"></i>
                                <span>Servers</span>
                            </button>
                        </li>
                    </ul>


                    <!-- Tab Content -->
                    <div class="tab-content" id="dashboardTabsContent">
                        <!-- Applications Tab -->
                        <div *ngIf="activeTab === 'applications'" class="tab-pane fade show active" id="applications"
                            role="tabpanel" aria-labelledby="applications-tab">
                            <div class="tab-content-wrapper">
                                <div class="applications-grid">
                                    <!-- MQTT -->
                                    <div class="metric-card mqtt-card">
                                        <div class="card-header">
                                            <div class="header-content">
                                                <div class="icon-wrapper mqtt-icon">
                                                    <i class="fas fa-broadcast-tower"></i>
                                                </div>
                                                <div class="header-text">
                                                    <h3>MQTT</h3>
                                                    <p>Message Queue Service</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            @if(mqttLoader){
                                            <div class="loading-container">
                                                <div class="gauge-skeleton" *ngFor="let i of [0, 1]">
                                                    <div class="skeleton-gauge"></div>
                                                    <div class="skeleton-text"></div>
                                                </div>
                                            </div>
                                            }@else{
                                            <div class="gauges-container">
                                                <div class="gauge-item">
                                                    <app-gauge-chart [canvasWidth]="180" [canvasHeight]="180"
                                                        [needleValue]="mqtt_data.service.gaugeData.needleValue"
                                                        [options]="mqtt_data.service.gaugeData.options"
                                                        [name]="mqtt_data.service.gaugeData.name"
                                                        [bottomLabel]="mqtt_data.service.gaugeData.bottomLabel">
                                                    </app-gauge-chart>
                                                </div>
                                                <div class="gauge-item">
                                                    <app-gauge-chart [canvasWidth]="180" [canvasHeight]="180"
                                                        [needleValue]="mqtt_data.processing.gaugeData.needleValue"
                                                        [options]="mqtt_data.processing.gaugeData.options"
                                                        [name]="mqtt_data.processing.gaugeData.name"
                                                        [bottomLabel]="mqtt_data.processing.gaugeData.bottomLabel">
                                                    </app-gauge-chart>
                                                </div>
                                            </div>
                                            }
                                        </div>
                                    </div>

                                    <!-- KURTOSIS -->
                                    <div class="metric-card kurtosis-card">
                                        <div class="card-header">
                                            <div class="header-content">
                                                <div class="icon-wrapper kurtosis-icon">
                                                    <i class="fas fa-chart-line"></i>
                                                </div>
                                                <div class="header-text">
                                                    <h3>Kurtosis</h3>
                                                    <p>Statistical Analysis</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            @if(mqttLoader){
                                            <div class="loading-container">
                                                <div class="gauge-skeleton" *ngFor="let i of [0, 1]">
                                                    <div class="skeleton-gauge"></div>
                                                    <div class="skeleton-text"></div>
                                                </div>
                                            </div>
                                            }@else{
                                            <div class="gauges-container">
                                                <div class="gauge-item">
                                                    <app-gauge-chart [canvasWidth]="180" [canvasHeight]="180"
                                                        [needleValue]="kurtosis_data.service.gaugeData.needleValue"
                                                        [options]="kurtosis_data.service.gaugeData.options"
                                                        [name]="kurtosis_data.service.gaugeData.name"
                                                        [bottomLabel]="kurtosis_data.service.gaugeData.bottomLabel">
                                                    </app-gauge-chart>
                                                </div>
                                                <div class="gauge-item">
                                                    <app-gauge-chart [canvasWidth]="180" [canvasHeight]="180"
                                                        [needleValue]="kurtosis_data.processing.gaugeData.needleValue"
                                                        [options]="kurtosis_data.processing.gaugeData.options"
                                                        [name]="kurtosis_data.processing.gaugeData.name"
                                                        [bottomLabel]="kurtosis_data.processing.gaugeData.bottomLabel">
                                                    </app-gauge-chart>
                                                </div>
                                            </div>
                                            }
                                        </div>
                                    </div>

                                    <!-- COMBINED DATA -->
                                    <div class="metric-card combined-card">
                                        <div class="card-header">
                                            <div class="header-content">
                                                <div class="icon-wrapper combined-icon">
                                                    <i class="fas fa-sitemap"></i>
                                                </div>
                                                <div class="header-text">
                                                    <h3>Combined Data</h3>
                                                    <p>Aggregated Metrics</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            @if(mqttLoader){
                                            <div class="loading-container">
                                                <div class="gauge-skeleton" *ngFor="let i of [0, 1]">
                                                    <div class="skeleton-gauge"></div>
                                                    <div class="skeleton-text"></div>
                                                </div>
                                            </div>
                                            }@else{
                                            <div class="gauges-container">
                                                <div class="gauge-item">
                                                    <app-gauge-chart [canvasWidth]="180" [canvasHeight]="180"
                                                        [needleValue]="combined_data.service.gaugeData.needleValue"
                                                        [options]="combined_data.service.gaugeData.options"
                                                        [name]="combined_data.service.gaugeData.name"
                                                        [bottomLabel]="combined_data.service.gaugeData.bottomLabel">
                                                    </app-gauge-chart>
                                                </div>
                                                <div class="gauge-item">
                                                    <app-gauge-chart [canvasWidth]="180" [canvasHeight]="180"
                                                        [needleValue]="combined_data.processing.gaugeData.needleValue"
                                                        [options]="combined_data.processing.gaugeData.options"
                                                        [name]="combined_data.processing.gaugeData.name"
                                                        [bottomLabel]="combined_data.processing.gaugeData.bottomLabel">
                                                    </app-gauge-chart>
                                                </div>
                                            </div>
                                            }
                                        </div>
                                    </div>


                                    <!-- IOT -->
                                    <!-- <div class="metric-card iot-card">
                                        <div class="card-header">
                                            <div class="header-content">
                                                <div class="icon-wrapper iot-icon">
                                                    <i class="fas fa-microchip"></i>
                                                </div>
                                                <div class="header-text">
                                                    <h3>IoT Services</h3>
                                                    <p>Device Management</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            @if(mqttLoader){
                                            <div class="loading-container">
                                                <div class="gauge-skeleton" *ngFor="let i of [0, 1, 2, 3, 4, 5]">
                                                    <div class="skeleton-gauge"></div>
                                                    <div class="skeleton-text"></div>
                                                </div>
                                            </div>
                                            }@else{

          
                                            <div class="iot-row combined-row">
                                                <div class="row-title">Combined Data</div>
                                                <div class="gauges-container">
                                                    <div class="gauge-item">
                                                        <app-gauge-chart [canvasWidth]="180" [canvasHeight]="180"
                                                            [needleValue]="iot_data.service.gaugeData.needleValue"
                                                            [options]="iot_data.service.gaugeData.options"
                                                            [name]="iot_data.service.gaugeData.name"
                                                            [bottomLabel]="iot_data.service.gaugeData.bottomLabel">
                                                        </app-gauge-chart>
                                                    </div>
                                                    <div class="gauge-item">
                                                        <app-gauge-chart [canvasWidth]="180" [canvasHeight]="180"
                                                            [needleValue]="iot_data.processing.gaugeData.needleValue"
                                                            [options]="iot_data.processing.gaugeData.options"
                                                            [name]="iot_data.processing.gaugeData.name"
                                                            [bottomLabel]="iot_data.processing.gaugeData.bottomLabel">
                                                        </app-gauge-chart>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="iot-row services-row">
                                                <div class="row-title">Services</div>
                                                <div class="gauges-container">
                                                    <div class="gauge-item"
                                                        *ngFor="let bot of iot_data_single.service_data | keyvalue">
                                                        <app-gauge-chart [canvasWidth]="180" [canvasHeight]="180"
                                                            [needleValue]="bot.value.service.gaugeData.needleValue"
                                                            [options]="bot.value.service.gaugeData.options"
                                                            [name]="bot.value.service.gaugeData.name"
                                                            [bottomLabel]="bot.value.service.gaugeData.bottomLabel">
                                                        </app-gauge-chart>
                                                    </div>
                                                </div>
                                            </div>

                                        
                                            <div class="iot-row processing-row">
                                                <div class="row-title">Processing</div>
                                                <div class="gauges-container">
                                                    <div class="gauge-item"
                                                        *ngFor="let bot of iot_data_single.processing_data | keyvalue">
                                                        <app-gauge-chart [canvasWidth]="180" [canvasHeight]="180"
                                                            [needleValue]="bot.value.processing.gaugeData.needleValue"
                                                            [options]="bot.value.processing.gaugeData.options"
                                                            [name]="bot.value.processing.gaugeData.name"
                                                            [bottomLabel]="bot.value.processing.gaugeData.bottomLabel">
                                                        </app-gauge-chart>
                                                    </div>
                                                </div>
                                            </div>
                                            }
                                        </div>
                                    </div> -->
                                    <!-- IOT -->
                                    <div class="metric-card iot-card">
                                        <div class="card-header">
                                            <div class="header-content">
                                                <div class="icon-wrapper iot-icon">
                                                    <i class="fas fa-microchip"></i>
                                                </div>
                                                <div class="header-text">
                                                    <h3>IoT Services</h3>
                                                    <p>Device Management</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            @if(mqttLoader){
                                            <div class="loading-container">
                                                <div class="gauge-skeleton" *ngFor="let i of [0, 1, 2, 3, 4, 5, 6, 7]">
                                                    <div class="skeleton-gauge"></div>
                                                    <div class="skeleton-text"></div>
                                                </div>
                                            </div>
                                            }@else{

                                            <!-- Row 1: Combined Data -->
                                            <!-- <div class="iot-row combined-row">
                                                <div class="row-title">Combined Data</div>
                                                <div class="gauges-container">
                                                    <div class="gauge-item">
                                                        <app-gauge-chart [canvasWidth]="150" [canvasHeight]="150"
                                                            [needleValue]="iot_data.service.gaugeData.needleValue"
                                                            [options]="iot_data.service.gaugeData.options"
                                                            [name]="iot_data.service.gaugeData.name"
                                                            [bottomLabel]="iot_data.service.gaugeData.bottomLabel">
                                                        </app-gauge-chart>
                                                    </div>
                                                    <div class="gauge-item">
                                                        <app-gauge-chart [canvasWidth]="150" [canvasHeight]="150"
                                                            [needleValue]="iot_data.processing.gaugeData.needleValue"
                                                            [options]="iot_data.processing.gaugeData.options"
                                                            [name]="iot_data.processing.gaugeData.name"
                                                            [bottomLabel]="iot_data.processing.gaugeData.bottomLabel">
                                                        </app-gauge-chart>
                                                    </div>
                                                </div>
                                            </div> -->

                                            <!-- Row 2: Services & Processing Combined -->
                                            <div class="iot-row services-processing-row">
                                                <div class="row-title">Instance Services & Processing</div>
                                                <div class="gauges-container combined-services-processing">
                                                    <!-- Services -->
                                                    <div class="gauge-item"
                                                        *ngFor="let bot of iot_data_single.service_data | keyvalue">
                                                        <app-gauge-chart [canvasWidth]="150" [canvasHeight]="150"
                                                            [needleValue]="bot.value.service.gaugeData.needleValue"
                                                            [options]="bot.value.service.gaugeData.options"
                                                            [name]="bot.value.service.gaugeData.name"
                                                            [bottomLabel]="bot.value.service.gaugeData.bottomLabel">
                                                        </app-gauge-chart>
                                                    </div>

                                                    <!-- Processing -->
                                                    <div class="gauge-item"
                                                        *ngFor="let bot of iot_data_single.processing_data | keyvalue">
                                                        <app-gauge-chart [canvasWidth]="150" [canvasHeight]="150"
                                                            [needleValue]="bot.value.processing.gaugeData.needleValue"
                                                            [options]="bot.value.processing.gaugeData.options"
                                                            [name]="bot.value.processing.gaugeData.name + ' (Processing)'"
                                                            [bottomLabel]="bot.value.processing.gaugeData.bottomLabel">
                                                        </app-gauge-chart>
                                                    </div>
                                                </div>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                    <!-- TRENDS -->
                                    <uptime-charts-container [type]="'application'" style="grid-column: span 3;"/>
                                </div>
                            </div>
                        </div>

                        <!-- Servers Tab -->
                        <div *ngIf="activeTab === 'servers'" class="tab-pane fade show active" id="servers"
                            role="tabpanel" aria-labelledby="servers-tab">
                            <div class="tab-content-wrapper">
                                <div class="servers-grid">
                                    <!-- COMBINED -->
                                    <div class="server-card database-card">
                                        <div class="card-header">
                                            <div class="header-content">
                                                <div class="icon-wrapper combined-icon">
                                                    <i class="fas fa-database"></i>
                                                </div>
                                                <div class="header-text">
                                                    <h3>Combined</h3>
                                                    <p>Operating Systems + Database</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            @if(service_loader){
                                            <div class="loading-container">
                                                <div class="gauge-skeleton" *ngFor="let i of [0]">
                                                    <div class="skeleton-gauge"></div>
                                                    <div class="skeleton-text"></div>
                                                </div>
                                            </div>
                                            }@else{
                                            <div class="gauges-container">
                                                <app-gauge-chart [canvasWidth]="180" [canvasHeight]="180"
                                                    [needleValue]="combined_os_gauge.processing.gaugeData.needleValue"
                                                    [options]="combined_os_gauge.processing.gaugeData.options"
                                                    [name]="combined_os_gauge.processing.gaugeData.name"
                                                    [bottomLabel]="combined_os_gauge.processing.gaugeData.bottomLabel">
                                                </app-gauge-chart>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                    <!-- DATABASE -->
                                    <div class="server-card database-card">
                                        <div class="card-header">
                                            <div class="header-content">
                                                <div class="icon-wrapper database-icon">
                                                    <i class="fas fa-database"></i>
                                                </div>
                                                <div class="header-text">
                                                    <h3>Database</h3>
                                                    <p>Data Storage Systems</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            @if(service_loader){
                                            <div class="loading-container">
                                                <div class="gauge-skeleton" *ngFor="let i of [0, 1]">
                                                    <div class="skeleton-gauge"></div>
                                                    <div class="skeleton-text"></div>
                                                </div>
                                            </div>
                                            }@else{
                                            <div class="gauges-container">
                                                <app-gauge-chart *ngFor="let db of db_data" [canvasWidth]="180"
                                                    [canvasHeight]="180"
                                                    [needleValue]="db.processing.gaugeData.needleValue"
                                                    [options]="db.processing.gaugeData.options"
                                                    [name]="db.processing.gaugeData.name"
                                                    [bottomLabel]="db.processing.gaugeData.bottomLabel">
                                                </app-gauge-chart>
                                            </div>
                                            }
                                        </div>
                                    </div>

                                    <!-- OPERATING SYSTEM -->
                                    <div class="server-card os-card">
                                        <div class="card-header">
                                            <div class="header-content">
                                                <div class="icon-wrapper os-icon">
                                                    <i class="fas fa-desktop"></i>
                                                </div>
                                                <div class="header-text">
                                                    <h3>Operating System</h3>
                                                    <p>System Resources</p>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="card-body">
                                            @if(service_loader){
                                            <div class="loading-container">
                                                <div class="gauge-skeleton" *ngFor="let i of [0, 1, 2, 3, 4]">
                                                    <div class="skeleton-gauge"></div>
                                                    <div class="skeleton-text"></div>
                                                </div>
                                            </div>
                                            }@else{
                                            <div class="gauges-container os-gauges">
                                                <app-gauge-chart *ngFor="let os of os_data" [canvasWidth]="180"
                                                    [canvasHeight]="180"
                                                    [needleValue]="os.processing.gaugeData.needleValue"
                                                    [options]="os.processing.gaugeData.options"
                                                    [name]="os.processing.gaugeData.name"
                                                    [bottomLabel]="os.processing.gaugeData.bottomLabel">
                                                </app-gauge-chart>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                    <uptime-charts-container [type]="'server'" style="grid-column: span 3;"/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>